import { client, getApiErrorMessage, stringifyQuery } from "utils/api";
import { toastr } from "react-redux-toastr";

export const compacted = (obj) =>
  Object.fromEntries(
    Object.entries(obj).filter(([_, value]) => {
      if (value == null) return false;
      if (Array.isArray(value) && value.length === 0) return false;
      return true;
    }),
  );

export const getRootTaxonLabel = ({ identifier, path_names }) => {
  const path_names_arr = path_names.split(" / ");
  let path_name = "";

  if ([1, 2].includes(path_names_arr.length)) {
    path_name = path_names_arr.join(" > ");
  } else {
    const first = path_names_arr[0];
    const last = path_names_arr[path_names_arr.length - 1];

    path_name = [first, "...", last].join(" > ");
  }

  return `[${identifier}] ${path_name}`;
};

export const getHeadStyle = (head) => {
  const styles = {};

  if (
    [
      "progress_status",
      "specification_product_group_workflow",
      "specification_product_workflow",
      "description_workflow",
      "category_workflow",
      "image_workflow",
      "title_workflow",
      "image_assign_workflow",
      "export_workflow",
    ].includes(head.id)
  ) {
    styles["textAlign"] = "center";
    styles["minWidth"] = "150px";
    styles["width"] = "150px";
  }

  return styles;
};

export const getRowStyle = ({ depth, original: { type } }) => {
  const styles = {};
  if (depth === 0) {
    styles["backgroundColor"] = "rgba(205, 205, 205, 0.8)";
    styles["cursor"] = "pointer";
  }
  if (depth === 1) {
    if (type === "Product") {
      styles["backgroundColor"] = "rgba(205, 205, 205, 0.5)";
      styles["cursor"] = "pointer";
    } else {
      styles["backgroundColor"] = "rgba(244, 176, 79, 0.5)";
    }
  }
  if (depth === 2) {
    styles["backgroundColor"] = "#fff";
  }
  return styles;
};

export const getCellStyle = ({ column }) => {
  const styles = {};
  if (
    [
      "progress_status",
      "specification_product_group_workflow",
      "specification_product_workflow",
      "description_workflow",
      "category_workflow",
      "image_workflow",
      "title_workflow",
      "image_assign_workflow",
      "export_workflow",
    ].includes(column.id)
  ) {
    styles["textAlign"] = "center";
  }
  return styles;
};

export const getData = async ({
  progress_status,
  past_product_group_ids = [],
  after_channel_product_id = undefined,
  in_product_group_id = undefined,
  query_filters = {},
}) => {
  try {
    return await client.get(
      `/channel_product_workflows${
        progress_status ? `/${progress_status}` : ""
      }?${stringifyQuery({
        past_product_group_ids,
        after_channel_product_id,
        in_product_group_id,
        ...query_filters,
      })}`,
    );
  } catch (error) {
    toastr.error("Błąd", getApiErrorMessage(error));
    throw error;
  }
};
